import { MenuItem, type MenuItemProps, Tooltip } from '@chakra-ui/react';

export interface MenuItemWithDisabledReasonProps extends MenuItemProps {
  disabledReason: string;
}

/**
 * Extends Chakra UI's MenuItem component to show a tooltip with the disabled reason when the item is disabled.
 */
export const MenuItemWithDisabledReason = ({
  disabledReason,
  isDisabled,
  ...menuItemProps
}: MenuItemWithDisabledReasonProps) => {
  return (
    <Tooltip
      label={disabledReason}
      hasArrow
      placement="right"
      isDisabled={!isDisabled}
    >
      <MenuItem isDisabled={isDisabled} {...menuItemProps} />
    </Tooltip>
  );
};
